import type { SVGProps } from 'react'
const SvgSyMapSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M9 17.47a1 1 0 0 0 .757.97l4 1A1 1 0 0 0 15 18.47V6.53a1 1 0 0 0-.757-.97l-4-1A1 1 0 0 0 9 5.53z" />
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M7 5.877a1 1 0 0 0-1.371-.929l-2 .8A1 1 0 0 0 3 6.677v11.846a1 1 0 0 0 1.371.928l2-.8A1 1 0 0 0 7 17.723zm10 12.246a1 1 0 0 0 1.371.928l2-.8a1 1 0 0 0 .629-.929V5.477a1 1 0 0 0-1.371-.929l-2 .8a1 1 0 0 0-.629.929z"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyMapSolid
